import get from 'lodash/get';
import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { type MapStateToProps, connect } from 'react-redux';

import * as BackstageConstants from '../../constants';
import * as D from '../../deps';
import BackstagePlayableRowGrid from '../BackstagePlayableRowGrid';
import BackstagePlayableRowItem from '../BackstagePlayableRowItem';

const CuratedStationsWithLogger = D.withVisibilityLogger({
  contentSection: BackstageConstants.BackstageSections.CURATOR_STATIONS,
})(BackstagePlayableRowGrid);

export interface ICuratedStationsStateProps {
  isMobileWeb: ReturnType<typeof D.isMobileWeb>;
}

export interface ICuratedStationsOwnProps {
  stations: $TSFixMe[];
  name?: string;
  pandoraId?: string;
  numberStations?: number;
  shareableUrlPath?: string;
  isFirstSection?: boolean;
  isMobileWeb?: boolean;
  currentPathname?: string;
}

export type ICuratedStationsProps = ICuratedStationsStateProps & ICuratedStationsOwnProps;

const CuratedStations: React.FC<ICuratedStationsProps> = props => {
  const { integration } = useContext(D.AppContext);

  const contentSection = BackstageConstants.BackstageSections.CURATOR_STATIONS;
  const integrationData = { contentSection };

  const onSeeAllStationsClick = (e: $TSFixMe): void => {
    integration.action.clicked({
      ...integrationData,
      destinationUrl: e.currentTarget.pathname,
    });
  };

  const moreUrl =
    props.shareableUrlPath && D.getBackstageAllStationsPathForShareUrl(props.shareableUrlPath);

  const numStationsToRender = props.isMobileWeb
    ? BackstageConstants.BackstageConstants.NUM_ITEMS_TO_RENDER_MOBILE_WEB
    : BackstageConstants.BackstageConstants.NUM_CURATOR_STATIONS_TO_RENDER;

  return (
    // @ts-expect-error TS(2322) FIXME: Type '{ children: any; contentSection: "stations_b... Remove this comment to see the full error message
    <CuratedStationsWithLogger
      contentSection={contentSection}
      title={
        props.name ? (
          <FormattedMessage
            {...BackstageConstants.messages.curatorStations}
            values={{ curatorName: props.name }}
          />
        ) : (
          <FormattedMessage {...BackstageConstants.messages.unnamedCuratorStations} />
        )
      }
      onSeeAllClick={onSeeAllStationsClick}
      moreUrl={moreUrl}
      moreText={
        props.stations?.length > numStationsToRender && (
          <FormattedMessage {...BackstageConstants.messages.viewAll} />
        )
      }
      secondMoreText={
        <FormattedMessage
          {...BackstageConstants.messages.curatorStationsNumber}
          values={{ number: props.numberStations }}
        />
      }
      isFirstSection={props.isFirstSection}
    >
      {props.stations.slice(0, numStationsToRender).map((station, index) => {
        const pandoraId = get(station, 'pandoraId', '');
        return (
          <BackstagePlayableRowItem
            key={pandoraId || index}
            pandoraId={pandoraId}
            itemUrl={get(station, 'shareableUrlPath')}
            itemName={get(station, 'name', '')}
            seedId={get(station, 'seedId.pandoraId', '')}
            pandoraType={D.PandoraTypes.STATION}
            playIndex={index}
            imgUrl={get(station, 'icon.artUrl', '')}
            hasBorderTopBottom={true}
            secondText={
              props.name ? (
                <FormattedMessage
                  {...BackstageConstants.messages.curatorStationSubtitle}
                  values={{ curatorName: props.name }}
                />
              ) : (
                <FormattedMessage {...BackstageConstants.messages.unnamedCuratorStationSubtitle} />
              )
            }
            thirdText={D.getInDomain('catalog.utils.displayListenerCount')(
              get(station, 'listenerCount'),
            )}
            secondTextUrl={''}
            dominantColor={get(station, 'icon.dominantColor', '')}
          />
        );
      })}
    </CuratedStationsWithLogger>
  );
};

export const mapStateToProps: MapStateToProps<
  ICuratedStationsStateProps,
  ICuratedStationsOwnProps,
  $TSFixMe
> = state => {
  return {
    isMobileWeb: D.isMobileWeb(state),
  };
};

export default connect(mapStateToProps)(CuratedStations);
